import { fmt } from "./storage";

export const SPECIES = [
  { key: "CaO", label: "CaO", M: 56, kind: "genel" },
  { key: "CaCO3", label: "CaCO₃", M: 100, kind: "genel" },
  { key: "Ca", label: "Ca²⁺", M: 40, kind: "genel" },
  { key: "Mg", label: "Mg²⁺", M: 24, kind: "genel" },
  { key: "MgO", label: "MgO", M: 40, kind: "genel" },
  { key: "MgCO3", label: "MgCO₃", M: 84, kind: "genel" },
  { key: "CaHCO3", label: "Ca(HCO₃)₂", M: 162, kind: "gecici" },
  { key: "MgHCO3", label: "Mg(HCO₃)₂", M: 146, kind: "gecici" },
  { key: "CaSO4", label: "CaSO₄", M: 136, kind: "kalici" },
  { key: "MgSO4", label: "MgSO₄", M: 120, kind: "kalici" },
  { key: "CaCl2", label: "CaCl₂", M: 111, kind: "kalici" },
  { key: "MgCl2", label: "MgCl₂", M: 95, kind: "kalici" },
];

export function classAS(as) {
  if (as < 4) return "Çok yumuşak";
  if (as < 8) return "Yumuşak";
  if (as < 12) return "Biraz sert";
  if (as < 18) return "Oldukça sert";
  if (as <= 30) return "Sert";
  return "Çok sert";
}

export function classWHO(mg) {
  if (mg < 75) return "Yumuşak";
  if (mg < 150) return "Orta sert";
  if (mg < 300) return "Sert";
  return "Çok sert";
}

const fromCaCO3 = (caco3) => ({
  caco3,
  cao: (caco3 / 100) * 56,
  as: ((caco3 / 100) * 56) / 10,
  fs: caco3 / 10,
  is: caco3 / 14.3,
  ppm: caco3,
});

export function computeHardness(inputs) {
  const steps = [];
  let total = 0, gecici = 0, kalici = 0;
  SPECIES.forEach((s) => {
    const mg = parseFloat(String(inputs[s.key] ?? "").replace(",", "."));
    if (!Number.isFinite(mg) || mg <= 0) return;
    const mmol = mg / s.M;
    total += mmol;
    if (s.kind === "gecici") gecici += mmol;
    if (s.kind === "kalici") kalici += mmol;
    steps.push({
      label: s.label,
      kind: s.kind,
      text: `${s.label}: ${fmt(mg)} mg ÷ ${s.M} g/mol = ${fmt(mmol, 3)} mmol → ${fmt(mmol * 56)} mg CaO eş. · ${fmt(mmol * 100)} mg CaCO₃ eş.`,
    });
  });
  const res = fromCaCO3(total * 100);
  return {
    steps,
    totalMmol: total,
    ...res,
    gecici: gecici > 0 ? fromCaCO3(gecici * 100) : null,
    kalici: kalici > 0 ? fromCaCO3(kalici * 100) : null,
    classAS: classAS(res.as),
    classWHO: classWHO(res.caco3),
  };
}

// Dönüştürücü: herhangi birimden mg CaCO3/L'ye
export const UNITS = [
  { key: "AS", label: "AS° (Alman)", toCaCO3: (v) => (v * 10 / 56) * 100 },
  { key: "FS", label: "FS° (Fransız)", toCaCO3: (v) => v * 10 },
  { key: "IS", label: "İS° (İngiliz)", toCaCO3: (v) => v * 14.3 },
  { key: "ppm", label: "ppm (mg CaCO₃/L)", toCaCO3: (v) => v },
];

export function convert(value, unitKey) {
  const v = parseFloat(String(value).replace(",", "."));
  const u = UNITS.find((x) => x.key === unitKey);
  if (!Number.isFinite(v) || !u) return null;
  return fromCaCO3(u.toCaCO3(v));
}
